import axios from "axios";

/**
 * Backend URL Logic:
 * 1. Checks for an environment variable (best for security/scaling).
 * 2. Falls back to your production API URL if the variable isn't found.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.fitest.co.uk"; 
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;

/**
 * Formats API errors into readable strings for the UI.
 */
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
